import React from 'react'
import * as jsonLogic from 'json-logic-js'
import CustomOfferBreakdown from './CustomOfferBreakdown'

export interface OverviewCopy {
  [key: string]: {
    title: string
    value: string
    displayCondition: string
  }
}

interface LearnMoreOverviewProps {
  copy?: OverviewCopy
}

function LearnMoreOverview({ copy }: LearnMoreOverviewProps) {
  if (!copy) return null

  const items = Object.values(copy)
    .filter(item => (item.displayCondition ? jsonLogic.apply(item.displayCondition) : true))
    .map(item => ({
      item: item.title,
      detail: {
        text: item.value,
        isStrong: true
      }
    }))

  return (
    <>
      <CustomOfferBreakdown
        items={items}
      />
    </>
  )
}

export default LearnMoreOverview
